import { memo } from "react";
import { closeIcon } from "../../icons";
interface DrivingHeaderProps {
    title: string;
    exitLabel: string;
    statusClass: string;
    statusText: string;
    onExit(): void;
}

export const DrivingHeader = memo(function DrivingHeader({
    title,
    exitLabel,
    statusClass,
    statusText,
    onExit,
}: DrivingHeaderProps) {
    return (
        <div className="driving-header">
            <button className="driving-exit-btn" onClick={onExit}>
                <span className="driving-exit-btn-icon" dangerouslySetInnerHTML={{ __html: closeIcon }} />
                <span className="driving-exit-btn-text">{exitLabel}</span>
            </button>
            <div className="driving-title">{title}</div>
            <div className="driving-status">
                <span className={`driving-status-dot ${statusClass}`} />
                <span>{statusText}</span>
            </div>
        </div>
    );
});